import { Component, SyntheticEvent } from "react";
import "../../../styles/css/searchspace.scss";
import "../../../App.css";
import { appContext } from "../../../AppContext";
import { Icons } from "../../../Common/AllsvgIcons";
import IbssSvgIcon from "../../Icons/SvgIcon/IbssSvgIcon";
import { Avatar, AvatarGroup, Box, Divider, TextField, Typography } from "@mui/material";
import IbssAutocomplete from "../../Inputs/AutoComplete/IbssAutocomplete";
import IbssDialog from "../../Dialogs/BaseDialog/IbssDialog";
import IbssTextField from "../../Inputs/TextField/IbssTextField";
import IbssButton from "../../Buttons/Button/IbssButton";
import { Button } from '@mui/material';
import { isEqual } from "lodash";
import UserPicker, * as UserPickerModule from "../../Inputs/UserPicker/UserPicker";
import { IbssComponent } from "../../Core/BaseComponent/IbssComponent";
import IbssAvatar from "../../Miscellaneous/Avatar/IbssAvatar";
import { Height } from "@mui/icons-material";
import Guid from "../../../Common/Guid";
import { Constants } from "../../../Common/Constants";
import { ICreateV2Booking_BookingParty } from "../../../Providers.Api/Models";
import { IVisitorChange, Visitor, VisitorField } from "../../Forms/Visitor/Visitor";
import React from "react";

export default class BookingPartiesPicker extends IbssComponent<IProps, IState>
{
    private visitorRef = React.createRef<Visitor>();
    private get labels() { return appContext().labels; }
    private get apiClient() { return appContext().apiClient; }

    constructor(props: IProps)
    {
        super(props);

        this.state = {
            allAttendees: [],
            showModal: false,
            isVisitor: false,
            nonVisitorAttendeesData: {
                email: "",
                name: "",
                organisation: "",
                resourceId: null,
                visitor: false,
                type: 1,
                visitorTypeId: '',
            },
            visitorAttendeesData: {
                email: "",
                name: "",
                organisation: "",
                resourceId: null,
                visitor: true,
                type: 2,
                visitorTypeId: '',
            },
            isVisitorValid: false,
            alreadyPresentError: '',
            selectedAttendee: '',
            booking_Parties_array: [],
            booking_Parties_Visitors_array: [],
            clearTriggered: false,
            visitorFirstName: '',
            visitorLastName: '',
            isAttendeeSelected: false,
        }
    }

    public componentDidMount(): void 
    {
        const { bookingParties, bookingPartyVisitors } = this.props;

        this.setState({
            allAttendees: [
                ...(bookingParties ?? []),
                ...(bookingPartyVisitors ?? []),
            ],
            booking_Parties_array: bookingParties ?? [],
            booking_Parties_Visitors_array: bookingPartyVisitors ?? [],
        });
    }

    public componentDidUpdate(prevProps: IProps): void
    {
        if (this.props.bookingParties && this.props.bookingPartyVisitors && (!isEqual(prevProps?.bookingParties, this.props?.bookingParties) || !isEqual(prevProps?.bookingPartyVisitors, this.props?.bookingPartyVisitors)))
        {
            this.setState({
                allAttendees: [...this.props.bookingParties, ...this.props.bookingPartyVisitors],
                booking_Parties_array: !this.props.hideExistingAttendees ? this.props.bookingParties : [],
                booking_Parties_Visitors_array: !this.props.hideExistingAttendees ?  this.props.bookingPartyVisitors : [],
            });
        }
    }

    private handleShowHideDialog(): void
    {
        this.setState({
            showModal: !this.state.showModal,
            isVisitor: false,
            nonVisitorAttendeesData:
            {
                email: "",
                name: "",
                organisation: "",
                resourceId: null,
                visitor: false,
                type: 1,
                visitorTypeId: '',
            },
            visitorAttendeesData:
            {
                email: "",
                name: "",
                organisation: "",
                resourceId: null,
                visitor: true,
                type: 2,
                visitorTypeId: '',
            },
            visitorFirstName: "",
            visitorLastName: ""
        });
    }

    private handleShowVisitor(): void
    {
        this.setState({
            isVisitor: !this.state.isVisitor,
            nonVisitorAttendeesData:
            {
                email: "",
                name: "",
                organisation: "",
                resourceId: null,
                visitor: false,
                type: 1,
                visitorTypeId: '',
            },
            visitorAttendeesData:
            {
                email: "",
                name: "",
                organisation: "",
                resourceId: null,
                visitor: true,
                type: 2,
                visitorTypeId: '',
            },
            isVisitorValid: true,
            alreadyPresentError: '',
            visitorFirstName: '',
            visitorLastName: ''
        })
    }

    private async handleNonVisitorSearch(text: string): Promise<void>
    {
        this.setState({ selectedAttendee: text });
        if (text.length <= 3)
        {
            this.setState({ alreadyPresentError: '' });
        }
    }

    private async handleNonVisitorSelect(attendee: UserPickerModule.IUser | null): Promise<void>
    {
        this.setState({ isAttendeeSelected: !!attendee });
        if (attendee)
        {
            const hubLabelalreadyPresent = this.state.booking_Parties_array.find((item: Attendee) => item.email === attendee.email);
            if (hubLabelalreadyPresent != null)
            {
                this.setState({
                    alreadyPresentError: this.labels.HubLabelalreadyPresent,
                    isVisitorValid: true,
                    selectedAttendee: '',
                });
            }
            else
            {
                this.setState({
                    nonVisitorAttendeesData: {
                        email: attendee.email,
                        name: attendee.firstName + ' ' + attendee.lastName,
                        organisation: attendee.company,
                        resourceId: null,
                        visitor: false,
                        type: 1,
                        visitorTypeId: '',

                    },
                    isVisitorValid: false,
                })
            }
        }
    }

    private async handleAddAttendee(): Promise<void>
    {
        if (!this.state.isVisitor)
        {
            const newBooking_Parties_array: Attendee[] = [...this.state.booking_Parties_array];
            newBooking_Parties_array.push(this.state.nonVisitorAttendeesData);
            this.setState({
                booking_Parties_array: newBooking_Parties_array,
                selectedAttendee: '',
                nonVisitorAttendeesData:
                {
                    email: "",
                    name: "",
                    organisation: "",
                    resourceId: null,
                    visitor: false,
                    type: 1,
                    visitorTypeId: '',
                },
                isVisitorValid: true,
            });
        }
        else
        {
            await this.setStateAsync({
                visitorAttendeesData: {
                    ...this.state.visitorAttendeesData,
                    name: `${this.state.visitorFirstName} ${this.state.visitorLastName}`.trim(),
                    email: this.getVisitorEmail(this.state.visitorAttendeesData.email),
                },
            });

            const newBooking_Parties_Visitors_array: Attendee[] = [...this.state.booking_Parties_Visitors_array];
            newBooking_Parties_Visitors_array.push(this.state.visitorAttendeesData);
            this.setState({
                booking_Parties_Visitors_array: newBooking_Parties_Visitors_array,
                visitorAttendeesData:
                {
                    email: "",
                    name: "",
                    organisation: "",
                    resourceId: null,
                    visitor: true,
                    type: 2,
                    visitorTypeId: '',
                },
                visitorFirstName: "",
                visitorLastName: "",
                isVisitorValid: true,
            });
            this.visitorRef.current?.resetValidation();
        }
    }

    private handleRemoveAttendee(item: Attendee): void
    {
        const newBooking_Parties_array: Attendee[] = this.state.booking_Parties_array.filter((element: Attendee) => element.email !== item.email);
        const newBooking_Parties_Visitors_array: Attendee[] = this.state.booking_Parties_Visitors_array.filter((element: Attendee) => element.email !== item.email);
        this.setState({
            booking_Parties_array: newBooking_Parties_array,
            booking_Parties_Visitors_array: newBooking_Parties_Visitors_array,
            clearTriggered: true,
        });
    }

    private handleClearAttendees(): void
    {
        if (this.state.booking_Parties_array.length == 0 && this.state.booking_Parties_Visitors_array.length == 0)
        {
            return;
        }
        this.setState({
            booking_Parties_array: [],
            booking_Parties_Visitors_array: [],
            isVisitorValid: true,
            clearTriggered: true,
        })
    }

    private handleSaveClick(): void
    {
        this.setState({ allAttendees: [...this.state.booking_Parties_array, ...this.state.booking_Parties_Visitors_array] });

        if (this.state.clearTriggered === true && this.state.booking_Parties_array.length === 0 && this.state.booking_Parties_Visitors_array.length === 0)
        {
            this.setState({
                allAttendees: [],
                clearTriggered: false,
            });
        }
        this.handleShowHideDialog();

        this.props.onSubmit(this.state.booking_Parties_array, this.state.booking_Parties_Visitors_array)
    }

    private getInitials(name: string): string
    {
        const firstName = name?.split(' ')[0];
        const lastName = name?.split(' ')[1];
        const firstNameInitial = firstName?.charAt(0)?.toUpperCase() ?? '';
        const lastNameInitial = lastName?.charAt(0)?.toUpperCase() ?? '';
        const firstLetters = firstNameInitial + lastNameInitial;
        return firstLetters;
    }

    private getVisitorEmail(visitorEmail: string): string
    {
        return (visitorEmail || `no-reply-${Guid.new()}@noreply.com`);
    }

    private handleVisitorChange(props: IVisitorChange): void
    {
        if (props.firstName != undefined) { this.setState({ visitorFirstName: props.firstName }); }
        if (props.lastName != undefined) { this.setState({ visitorLastName: props.lastName }); }
        if (props.company != undefined) { this.setState({ visitorAttendeesData: { ...this.state.visitorAttendeesData, organisation: props.company } }); }
        if (props.email != undefined) { this.setState({ visitorAttendeesData: { ...this.state.visitorAttendeesData, email: props.email } }); }
        if (props.visitorTypeId != undefined) { this.setState({ visitorAttendeesData: { ...this.state.visitorAttendeesData, visitorTypeId: props.visitorTypeId } }); }
    }

    private handleVisitorValidate(isValid: boolean): void
    {
        this.setState({ isVisitorValid: isValid });
    }

    public render(): JSX.Element
    {
        const isButtonDisabled = (this.state.booking_Parties_array.length === 0 && this.state.booking_Parties_Visitors_array.length === 0) && this.state.clearTriggered === false;
        const isValid = (this.state.isVisitor ? this.state.isVisitorValid : this.state.isAttendeeSelected);

        return (
            <>
                {this.props.linkOnly ?
                    <>
                        <IbssButton onClick={() => this.handleShowHideDialog()}>+{this.labels.HubLabelAddButton}</IbssButton>
                    </>
                    :
                    <Button fullWidth disabled={this.props.disabled} sx={{ justifyContent: 'space-between', display: 'flex', textTransform: 'capitalize' }} className="row attendes cp" onClick={() => this.handleShowHideDialog()}>
                        <div className="icon-text-inline pl-0">
                            {(this.state.booking_Parties_array.length === 0 && this.state.booking_Parties_Visitors_array.length === 0) && (
                                <>
                                    <div className="d-flex space-between mr-2">
                                        <span className="space-icon-item">
                                            <Box sx={{ fontSize: '26px', color: 'var(--ui-text)' }}>
                                                <IbssSvgIcon fontSize='small' className="mr-2">
                                                    {Icons.AddAttendeeIcon}
                                                </IbssSvgIcon>
                                            </Box>
                                            <span className="space-text-item col-text">{this.state.allAttendees.length === 0 && this.labels.HubLabelAddAttendeeLabel}</span>
                                        </span>
                                    </div>
                                    <hr style={{ marginBottom: '0.5rem' }} />
                                </>
                            )}
                            <span className="ml-1 d-flex">
                                <AvatarGroup className="BokingoptionsAvtar" total={this.state.allAttendees.length}>
                                    {this.state.allAttendees.slice(0, 5).map((item: Attendee, index: number) => (
                                        <Avatar sx={{ backgroundColor: 'var(--ui-secondary)', border: '1px solid var(--ui-text-alternate)', color: 'var(--ui-light-text)', height: 30, width: 30, fontSize: 14 }}>{this.getInitials(item.name)}</Avatar>
                                    ))}
                                </AvatarGroup>
                            </span>
                        </div>
                        <div className="d-flex">
                            <span className="space-text-item">{this.state.allAttendees.length !== 0 && `${this.state.allAttendees.length} ${this.labels.HubLabelAttendees}`}</span>
                            <IbssSvgIcon fontSize='medium' className="" sx={{ color: (theme) => theme.palette.text.primary }}>
                                {Icons.RightArrowIcon}
                            </IbssSvgIcon>
                        </div>
                    </Button>
                }
                <Divider className="my-1" />
                {
                    this.state.showModal &&
                    <IbssDialog
                        aria-modal="true"
                        aria-label="attendee selection modal"
                        open={this.state.showModal}
                        fullWidth
                        onClose={() => this.handleShowHideDialog()}
                        onClick={e => e.stopPropagation()}
                        header=
                        {
                            <>
                                <label className="modal-heading">{this.labels.HubLabelAttendeeSelection}</label>
                            </>
                        }
                        dialogContent=
                        {
                            <div>

                                <div className="d-flex justify-content-between">
                                    <label className="lable-modal">{this.labels.HubButtonVisitorAccess}</label>
                                    <input name="isPrivate" disabled={this.props.disableVisitorParties} type="checkbox" className="input-check-box-label border checkbox-sm" checked={this.state.isVisitor} onChange={() => this.handleShowVisitor()} />
                                </div>

                                <hr className="m-0 mx-2" />

                                {!this.state.isVisitor &&
                                    <div className="mt-2">
                                        <div className="form-group mt-3 mx-10">
                                            <label className="py-1">{this.labels.HubLabelnameEmailAddress}</label>
                                            <UserPicker
                                                searchText={this.state.selectedAttendee}
                                                onChange={async text => this.handleNonVisitorSearch(text)}
                                                onUserChange={user => this.handleNonVisitorSelect(user)}
                                            />
                                            <div className="text-danger">{this.state.alreadyPresentError}</div>
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.isVisitor &&
                                    <Visitor
                                        ref={this.visitorRef}
                                        sx={{ padding: 0 }}
                                        fields={VisitorField.Name | VisitorField.Company | VisitorField.Email | VisitorField.VisitorType}
                                        buildingId={this.props.buildingId}
                                        firstName={this.state.visitorFirstName}
                                        lastName={this.state.visitorLastName}
                                        company={this.state.visitorAttendeesData.organisation}
                                        email={this.state.visitorAttendeesData.email}
                                        visitorTypeId={this.state.visitorAttendeesData.visitorTypeId}
                                        onChange={e => this.handleVisitorChange(e)}
                                        onValidate={e => this.handleVisitorValidate(e)}
                                    />
                                }
                                <div className="form-group mx-10">
                                    <IbssButton
                                        variant='contained'
                                        onClick={() => this.handleAddAttendee()}
                                        disabled={!isValid}
                                    >
                                        {this.labels.HubButtonAddattendeebutton}
                                    </IbssButton>
                                </div>
                            </div>
                        }
                        footer=
                        {
                            <div className="w-100">
                                {this.state.booking_Parties_array.length > 0 && (
                                    <>
                                        <div className="px-58 form-group ml-10">
                                            <label className="py-1 lable-modal-bold">{this.labels.HubLabelAttendees}</label>
                                            <div className="d-flex flex-wrap">
                                                {this.state.booking_Parties_array.map((item: Attendee) => (
                                                    <>
                                                        <p className="attendee-name mr-3">{item.name} <i tabIndex={0} className="fa fa-times-circle-o" aria-hidden="true" onKeyDown={(e) => { e.key === 'Enter' && this.handleRemoveAttendee(item) }} onClick={() => this.handleRemoveAttendee(item)}></i></p>
                                                    </>
                                                ))}
                                            </div>
                                        </div>
                                        <hr className="attendee-hr" />
                                    </>
                                )}
                                {this.state.booking_Parties_Visitors_array.length > 0 && (
                                    <>
                                        <div className="px-58 form-group ml-10 mt-1">
                                            <label className="py-1 lable-modal-bold">{this.labels.HubLabelVisitorAttendee}</label>
                                            <div className="d-flex flex-wrap">
                                                {this.state.booking_Parties_Visitors_array.map((item: Attendee) => (
                                                    <p className="attendee-name mr-3 mb-0">{item.name} <i tabIndex={0} className="fa fa-times-circle-o" aria-hidden="true" onKeyDown={(e) => { e.key === 'Enter' && this.handleRemoveAttendee(item) }} onClick={() => this.handleRemoveAttendee(item)}></i></p>
                                                ))}
                                            </div>
                                        </div>
                                        <hr className="attendee-hr" />
                                    </>
                                )}
                                <Box className="px-58">
                                    { this.props.spaceCapacity && (this.state.booking_Parties_array.length + this.state.booking_Parties_Visitors_array.length >= this.props.spaceCapacity) &&
                                        <Box mt={2} sx={{ bgcolor: 'var(--ui-warn-pastel)', color: 'primary.secondaty', p: 1, borderRadius: 1 }}>
                                            <Typography variant="body2">{this.labels.funcBookingAttendanceExceedsWarningMessage}</Typography>
                                        </Box>
                                    }
                                    <Box className="mt-1 pw-100 d-flex justify-content-end">
                                        <a href="#" className="clear-attendees" onClick={() => this.handleClearAttendees()} >{this.labels.HubButtonClearAttendees}</a>
                                        <IbssButton
                                            className='ml-2'
                                            variant='contained'
                                            disabled={isButtonDisabled}
                                            onClick={() => this.handleSaveClick()}
                                        >
                                            {this.labels.HubButtonSave}
                                        </IbssButton>
                                    </Box>
                                </Box>
                            </div>
                        }
                    />
                }
            </>
        );
    }
}

export interface IState
{
    showModal: boolean;
    allAttendees: Attendee[];
    isVisitor: boolean;
    nonVisitorAttendeesData: Attendee;
    visitorAttendeesData: Attendee;
    isVisitorValid: boolean;
    alreadyPresentError: string;
    selectedAttendee: string;
    booking_Parties_array: Attendee[];
    booking_Parties_Visitors_array: Attendee[];
    clearTriggered: boolean;
    visitorFirstName: string;
    visitorLastName: string;
    isAttendeeSelected: boolean;
}

export interface IProps
{
    buildingId: number;
    bookingParties?: Attendee[];
    bookingPartyVisitors?: Attendee[];
    disabled?: boolean;
    showModalExternal?: boolean;
    linkOnly?: boolean;
    onSubmit: (parties: Attendee[], visitors: Attendee[]) => void;
    hideExistingAttendees?: boolean;
    disableVisitorParties?: boolean;
    spaceCapacity?: number;
}

export class Attendee
{
    public email: string;
    public name: string;
    public organisation: string;
    public resourceId: string | null;
    public visitor: boolean;
    public type: number;
    public backgroundColor?: string;
    public visitorTypeId: string;
    public recordId?: string;

    constructor(data: ICreateV2Booking_BookingParty)
    {
        this.email = data.Booking_Participant_Email;
        this.name = data.Booking_Participant_Name;
        this.organisation = data.Booking_Participant_Organisation;
        this.resourceId = data.Booking_Resource_Id;
        this.visitor = data.Booking_Visitor;
        this.type = data.Booking_Participant_Type;
        this.visitorTypeId = data.VisitorTypeId;
        this.recordId = data.Record_Id;
    }
}
